module.exports = __webpack_public_path__ + "img/training-top.eb5f236c.jpg";